module.exports = __webpack_public_path__ + "img/bet-stop.40e3ec46.png";